import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
export const useSearchState = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [advanceSearch, setAdvanceSearch] = useState(false);
    const [inputValue, setInputValue] = useState('');
  
    useEffect(() => {
      const advanceSearchParam = searchParams.get('advanceSearch');
      if (advanceSearchParam) {
        setAdvanceSearch(true);
      } else {
        setInputValue(searchParams.get('search') || '');
        setAdvanceSearch(false);
      }
    }, [searchParams]);
  
    const handleSearchSubmit = (searchString: string) => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('page', '1');
      ['filter', 'value', 'operator', 'advanceSearch'].forEach(param => 
        newParams.delete(param));
  
      if (searchString) {
        newParams.set('search', searchString);
      } else {
        newParams.delete('search');
      }
      setSearchParams(newParams);
    };
  
    return {
      searchParams,
      advanceSearch,
      setAdvanceSearch,
      inputValue,
      setInputValue,
      handleSearchSubmit
    };
  };